import isEmpty from 'lodash/isEmpty'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { Button, If, Text, Unless } from '../../../..'
import { saveClientAnswer } from '../../../../../actions/client'
import {
  PRIORITY_ICON_MAP,
  PRIORITY_MESSAGE_MAP,
  PRIORITY_OPTIONS,
  QUESTION_PRIORITY
} from '../../../../../constants/client/onboarding'
import { TrackingEventHelpers } from '../../../../../helpers/tracking'
import { selectAnswerPriority } from '../../../../../store/selectors/client'
import { useWizardProvider } from '../../../../shared/WizardContext'
import Goal from '../../Goal'
import { WizardButtonGroup } from '../Button'

import { useTrackingContext } from '../../../../../providers/tracking'
import baseStyles from '../../BuyerOnboardingWizard.module.scss'

const EnterPriority = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const { trackingClient } = useTrackingContext()
  const { goBack, goForward } = useWizardProvider()
  const priority = useSelector(selectAnswerPriority)

  const savePriority = value => {
    trackingClient?.buyerOnboarded({
      market_criteria: TrackingEventHelpers.getTrackingMarketCriteria(value)
    })
    dispatch(
      saveClientAnswer({
        question: QUESTION_PRIORITY,
        response: {
          value
        }
      })
    )
    goForward()
  }

  return (
    <div className={baseStyles.step} data-qa='enter-priority'>
      <div>
        <Text.Headline>
          <FormattedMessage id='NewBuyerOnboarding.priority.headline' defaultMessage='What matters most to you?' />
        </Text.Headline>
      </div>
      <div className={baseStyles.goalsContainer}>
        {PRIORITY_OPTIONS.map(goal => {
          const copy = PRIORITY_MESSAGE_MAP[goal] || null
          const formattedCopy = intl.formatMessage(copy)
          const Icon = PRIORITY_ICON_MAP[goal] || null

          return (
            <Goal
              goal={goal}
              copy={formattedCopy}
              icon={Icon}
              key={goal}
              onClick={savePriority}
              selectedGoal={priority}
            />
          )
        })}
      </div>
      <WizardButtonGroup>
        <Button.Back onClick={goBack} />
        <Button.Forward onClick={goForward}>
          <Unless condition={isEmpty(priority)}>
            <FormattedMessage id='NewBuyerOnboarding.buttonGroup.continue' defaultMessage='Continue' />
          </Unless>
          <If condition={isEmpty(priority)}>
            <FormattedMessage id='NewBuyerOnboarding.buttonGroup.skip' defaultMessage='Skip for now' />
          </If>
        </Button.Forward>
      </WizardButtonGroup>
    </div>
  )
}

export default EnterPriority
